/**
 * Export Button Component
 * 
 * A reusable button to open the Export Panel
 * Used across exhibits (EX1-EX9)
 */

import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export interface ExportButtonProps {
  onClick: () => void;
  title?: string;
  loading?: boolean;
  disabled?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  onClick,
  title = 'Export data',
  loading = false,
  disabled = false,
}) => {
  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={onClick}
      title={title}
      loading={loading}
      disabled={disabled}
      style={{ width: 40, height: 40 }}
    />
  );
};

export default ExportButton;
